import ConservationState from "./enums/ConservationState";
import UsageTypes from "./enums/UsageTypes";
import DocumentState from "./enums/DocumentState";
import CHUsage from "./CHUsage";
import InspectionMode from "./InspectionMode";
import Annotation from "./Annotation";
import {User} from "./User";
import InspectionModeItem from "./InspectionModeItem";
import CHUsageItem from "./CHUsageItem";

class ConditionReport {
  constructor(
    public id_user: number,
    public id_e3dmodel: number,
    public id_province: number,
    public id_municipality: number,

    // General information
    public address: string,
    public name: string,
    public date: string,
    public author: string,
    public cultural_sphere: string,
    public legal_status: string,
    public conservation_history: string,

    // Only for buildings (immovable)
    public reference_cartography_municipality: string,
    public reference_cartography_cadastral_sheet: string,
    public reference_cartography_cadastral_parcel: string,
    public reference_cartography_other: string,
    // Only for objects (movable)
    public parent_asset_name: string,
    public specific_location: string,
    public colocation_characteristics: string,

    public description: string,
    public techniques: string,
    // Only for objects (movable)
    public object: string,
    public subject: string,

    // Diagnosis
    // Alteration Events will be added
    public diagnosis_description: string,
    public state_of_conservation: ConservationState,

    // Survey information
    // inspection mode is a n to n relation
    public environmental_conditions_temperature: string,
    public environmental_conditions_relative_humidity: string,
    public environmental_conditions_current_weather_condition: string,
    public environmental_conditions_past_week_weather_condition: string,
    public survey_date: string,
    // survey records to be added as files
    public report_references: string,

    // Additional information
    public status: DocumentState,
    public survey_responsible: string,

    public id_annotations: Array<number> | undefined,

    public annotations: Array<Annotation> | undefined,
    // public ch_usages: Array<number> | undefined,
    // public inspection_modes: Array<number> | undefined,

    // public ch_usages?: CHUsage[],
    public ch_usages?: CHUsageItem[],
    // public inspection_modes?: Array<InspectionMode> | undefined,
    public ch_inspection_modes?: InspectionModeItem[],

    public id_users?: number[],

    public id?: number | undefined,
    public GUID?: string | undefined,
    public created_on?: Date | undefined,

    public users?: User[]
  ) {}

  public static EmptyInstance(): ConditionReport {
    return new ConditionReport(
      -1, // id_user
      -1, // id_3dmodel
      -1, // id_province
      -1, // id_municipality
      "", // address
      "", // name
      "", // date
      "", // author
      "", // cultural_sphere
      "", // legal_status
      "", // conservation_history
      "", // reference_cartography_municipality
      "", // reference_cartography_cadastral_sheet
      "", // reference_cartography_cadastral_parcel
      "", // reference_cartography_other
      "", // parent_asset_name
      "", // specific_location
      "", // colocation_characteristics
      "", // description
      "", // techniques
      "", // object
      "", // subject
      "", // diagnosis_description
      ConservationState.Good, // state_of_conservation
      "", // environmental_conditions_temperature
      "", // environmental_conditions_relative_humidity
      "", // environmental_conditions_current_weather_condition
      "", // environmental_conditions_past_week_weather_condition
      "", // survey_date
      "", // report_references
      DocumentState.draft, // status
      "", // survey_responsible
      undefined, // id_annotations
      undefined, // ch_usages
      undefined, // inspection_modes
      // [], // id_annotations
      undefined,
      // [], // ch_usages
      // [], // inspection_modes
      undefined, // id
      undefined, // GUID
      undefined // created_on
    );
  }

  public static GetProgress(report: ConditionReport): number {
    let total = 0;
    let populated = 0;
    let key: keyof ConditionReport;
    // go through all the properties
    for (key in report) {
      total++;
      if (report[key]) {
        if (!Array.isArray(report[key])) {
          populated++;
        } else if (Array(report[key]).length > 0) {
          populated++;
        }
      }
    }
    return Math.round((populated / total) * 100);
  }
  
}

export default ConditionReport;
